const handler = tracker => ({
  trackDirectiveCouncilTab: metadata => {
    tracker().trackEvent("Ha abierto la pestaña de consejo directivo", metadata)
  }
})

export default handler